import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useTheme } from "@/theme/useTheme";

export default function NotFound() {
  const location = useLocation();
  const { t } = useTranslation();
  const { theme } = useTheme();
  const isDark = theme === "dark";
  
  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4" style={{ background: 'var(--app-bg)', color: 'var(--text-primary)' }}>
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black select-none pointer-events-none z-0" style={{ color: isDark ? 'rgba(255,255,255,0.04)' : '#f8fafc' }}>
        404
      </h1>
      <div className="relative z-10">
        <h1 className="text-xl md:text-2xl font-semibold mt-6">{t('notFound.title')}</h1>
        <p className="mt-2 text-base font-mono" style={{ color: 'var(--text-muted)' }}>{location.pathname}</p>
        <p className="mt-4 text-lg md:text-xl" style={{ color: 'var(--text-secondary)' }}>{t('notFound.description')}</p>
      </div>
    </div>
  );
}
